"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeDiscountedAmount = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var types_1 = require("../../../types");
var big_numbers_1 = require("../../../utils/big-numbers");
var compute_tax_rate_1 = require("../../tax-rate/compute-tax-rate");
var utils_1 = require("./utils");
var computeDiscountedAmount = function (_a) {
    var itemPriceNotRounded = _a.itemPriceNotRounded, taxRate = _a.taxRate, discount = _a.discount, totalPriceWithDiscount = _a.totalPriceWithDiscount;
    var oldPriceInclTax = itemPriceNotRounded.totalInclTaxWithDiscount;
    var oldPriceExclTax = itemPriceNotRounded.totalExclTaxWithDiscount;
    var discountValue = new bignumber_js_1.default(discount.amount);
    // if product price is already zero, do not apply discount
    if (oldPriceInclTax.comparedTo(big_numbers_1.big0) === 0) {
        return {
            discountedAmountInclTax: big_numbers_1.big0,
            discountedAmountExclTax: big_numbers_1.big0,
        };
    }
    var discountedAmount;
    if (discount.applyMethod === types_1.APPLY_METHOD.ABSOLUTE) {
        discountedAmount = (0, utils_1.computeAbsoluteDiscountedAmount)(oldPriceInclTax, discountValue, totalPriceWithDiscount);
    }
    else {
        discountedAmount = (0, utils_1.computeRateDiscountedAmount)(oldPriceInclTax, discountValue, discount.threshold, discount.ceiling, totalPriceWithDiscount);
    }
    // if the discount value is greater than the product price, we don't apply the discount, unless it's loyalty or promocode
    if (discountedAmount.comparedTo(oldPriceInclTax) === 1) {
        if (discount.type === types_1.DISCOUNT_TYPE.LOYALTY || discount.type === types_1.DISCOUNT_TYPE.PROMOCODE) {
            discountedAmount = oldPriceInclTax;
        }
        else {
            return {
                discountedAmountInclTax: big_numbers_1.big0,
                discountedAmountExclTax: big_numbers_1.big0,
            };
        }
    }
    var newPriceInclTax = oldPriceInclTax.minus(discountedAmount);
    var newPriceExclTax = (0, compute_tax_rate_1.computeExclTaxFromInclTax)(newPriceInclTax, taxRate);
    var discountedAmountExclTax = oldPriceExclTax.minus(newPriceExclTax);
    return {
        discountedAmountInclTax: discountedAmount,
        discountedAmountExclTax: discountedAmountExclTax,
    };
};
exports.computeDiscountedAmount = computeDiscountedAmount;
